export const isInsuranceGuard = (service) => {
    return !!service.code;
};
export const isGdsServiceGuard = (service) => {
    return 'confirmedCount' in service;
};
